export class MenuItem {
    route: string;
    display: string;
    name: string;
    roles: string[];
    parent: string;
    isParent: boolean;
    showChilden: boolean;
    icon: string;
    active: boolean;
  
    constructor(
      route: string,
      display: string,
      name: string,
      roles: string[],
      parent = '',
      isParent = false,
      icon = '',
      active = true,
    ) {
      this.route = route;
      this.display = display;
      this.roles = roles;
      this.name = name;
      this.parent = parent;
      this.isParent = isParent;
      this.icon = icon;
      this.active = active;
    }
  }